import Page from "../../components/Page"
import BurnForm from "../../forms/BurnForm"

const Burn = () => {
  return (
    <Page>
      <BurnForm />
    </Page>
  )
}

export default Burn
